import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'
import { URL_SERVICIOS_AWS } from '../../config/url.servicio';
import { Turnos } from '../../models/turnos/turnos.models';

@Injectable()
export class ReservasProvider {
    token:string
    companiaId:number
    usuarioId: number;

    constructor(
        public http: Http, private storage:Storage) {
        this.storage.get('token').then((val) => {
            this.token = val
        });

        this.storage.get('companiasId').then(async (val) => {
            this.companiaId = val
        })
      this.storage.get('usuariosId').then((usuario) => {
            this.usuarioId = usuario
        });

    }

    buscarReservas(companiaId: any) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarReservas",
          parameters : {companiaId:companiaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
    }

    buscarSeguimientoReservas(companiaId: any, id: any, tipo: any, turno:any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarSeguimientoReservas",
        parameters : {companiaId:companiaId, id: id, tipo: tipo, turno:turno}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  buscarClientesId(clientesId:any, companiaId: any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarClientesId",
      parameters : {clientesId:clientesId,companiasId:companiaId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}


  guardarReserva(turno: Turnos, actualizar: boolean ) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarReserva",
      parameters : {
        companiasId:turno.companiasId,
        clientesId:turno.clientesId,
        usuariosId:turno.usuariosId,
        fechaInicio: turno.fechaInicio,
        fechaFin: turno.fechaFin,
        codigo:turno.codigo,
        productosElaboradosId:turno.productosElaboradosId,
        mesasId:turno.mesasId,
        gruposReservasPorProductoId:turno.gruposReservasPorProductoId,
        nombre:turno.nombre,
        valorImpuesto:turno.valorImpuesto,
        valorProducto:turno.valorProducto,
        porcentajeImpuesto:turno.porcentajeImpuesto,
        actualizar:actualizar === true ? 'S': 'N',
        turnoactual: turno.turno
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

buscarSeguimientoReservasDiaAsignado(companiaId: any,id: any,tipo: any,turno: any, igualAlturno: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarSeguimientoReservasDiaAsignado",
    parameters : {
      companiaId:companiaId,
      id:id,
      tipo:tipo,
      turno:turno,
      igualAlturno:igualAlturno
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

buscarClientesPorCompaniaGeneral(companiaId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarClientesPorCompaniaGeneral",
    parameters : {companiasId:companiaId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}
calcularValorLiquidarReservas(companiaId: any,turno:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "calcularValorLiquidarReservas",
    parameters : {companiasId:companiaId,turno:turno}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

buscarParqueaderos(companiaId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarParqueaderos",
    parameters : {companiaId:companiaId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

async buscarSeguimientoParqueaderosToPromise(companiaId: any, id: any, tipo: any, turno:any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarSeguimientoParqueaderos",
      parameters : {companiaId:companiaId, id: id, tipo: tipo, turno:turno}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response
  } catch (error) {
    console.error('Error al obtener la información:', error);
    throw error;
  }
}

buscarSeguimientoParqueaderos(companiaId: any, id: any, tipo: any, turno:any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarSeguimientoParqueaderos",
      parameters : {companiaId:companiaId, id: id, tipo: tipo, turno:turno}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } catch (error) {
    console.error('Error al obtener la información:', error);
    throw error;
  }
}


buscarSeguimientoParqueaderosDiaAsignado(companiaId: any,id: any,tipo: any,turno: any, igualAlturno: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarSeguimientoParqueaderosDiaAsignado",
    parameters : {
      companiaId:companiaId,
      id:id,
      tipo:tipo,
      turno:turno,
      igualAlturno:igualAlturno
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}
async buscarSeguimientoParqueaderosPorPlaca(companiaId: any, placa: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarSeguimientoParqueaderosPorPlaca",
    parameters : {companiaId:companiaId, placa: placa}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  const response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();

  return response;
}

async devolverCompaniasId() {
  try {
    const val = await this.storage.get('companiasId');
    this.companiaId = val;
    return this.companiaId;
  } catch (error) {
    console.error('Error al obtener el ID de la compañía:', error);
    throw error;
  }
}

async guardarParqueadero(turno: Turnos, actualizar: boolean, estadosParqueaderosId:any = 0 ) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarParqueadero",
      parameters : {
        companiasId:turno.companiasId,
        clientesId:turno.clientesId == undefined ? 0 : turno.clientesId,
        usuariosId:turno.usuariosId== undefined ? 0 : turno.usuariosId,
        codigo:turno.codigo,
        productosElaboradosId:turno.productosElaboradosId,
        nombre:turno.nombre == undefined ? ' ' : turno.nombre,
        valorImpuesto:turno.valorImpuesto,
        valorProducto:turno.valorProducto,
        porcentajeImpuesto:turno.porcentajeImpuesto,
        actualizar:actualizar === true ? 'S': 'N',
        turnoactual: turno.turno,
        estadosParqueaderosId: estadosParqueaderosId
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise()
    return response
  } catch (error) {
    console.error('Error al guardar la placa:', error);
    throw error;
  }

}

async buscarEstadosParqueaderoControlaPrecioSi(companiasId: any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarEstadosParqueaderoControlaPrecioSi",
      parameters : {companiasId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response
  } catch (error) {
    console.error('Error al obtener la información:', error);
    throw error;
  }
}

async buscarSeguimientoParqueaderosSinExistencia(companiasId: any, productosElaboradosId: any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarSeguimientoParqueaderosSinExistencia",
      parameters : {companiasId:companiasId,productosElaboradosId:productosElaboradosId }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response
  } catch (error) {
    console.error('Error al obtener la información:', error);
    throw error;
  }
}

}



// WEBPACK FOOTER //
// ./src/providers/reservas/reservas.ts